import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { TextButton, IconType } from '@checkmarx/cx-ui';
import EditAdvancedRoleMappingDialog from '../editAdvancedRoleMappingDialog';

@inject('translationsStore', 'ldapRoleMappingsStore') @observer
export default class EditAdvancedRoleMappingButton extends Component {
    
    state = {
        openDialog: false
    }
    
    openDialog = () => {

        this.props.ldapRoleMappingsStore.getLdapRoleMappings(this.props.ldapServerId).then(() => {
            this.setState({ 
                openDialog: true
            });
        });
    }

    closeDialog = () => {

        this.setState({ 
            openDialog: false
        });
        this.props.ldapRoleMappingsStore.reset();
    }

    render() {

        return (
            
            <div>
                <TextButton
                    dataCy='edit-advanced-role-mapping-button'
                    text={this.props.translationsStore.translate('EDIT_ADVANCED_ROLE_MAPPING')}
                    iconType={IconType.edit}
                    onClick={this.openDialog} />
                <EditAdvancedRoleMappingDialog 
                    open={this.state.openDialog}
                    closeDialog={this.closeDialog}
                    ldapServerId={this.props.ldapServerId}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/advancedRoleMappings/editAdvancedRoleMappingButton/index.jsx